<template>
  <v-card flat tile >
    <request-status :request='req' />
    <!-- <v-card-title class='subtitle-1 overline' >
    Create a member
  </v-card-title> -->
    <v-window v-model="step" vertical flat >

      <v-card dark dense tile flat
        v-if="selectedSpaceObjects && selectedSpaceObjects.length > 0" >
        <!-- <pre v-text="member" class="caption pa-2 grey lighten-4" /> -->
        <v-card-title
          class='subtitle-1 overline py-0'>
          Add
          <v-chip x-small class="mx-2" color="info" v-if="member.role && member.role.title" >{{member.role.title}}
          </v-chip>

          <template v-if="selectedSpaceObjects && selectedSpaceObjects.length > 0">
            to
            <v-chip v-for="space in selectedSpaceObjects" :key="space.id" class="ml-2" x-small label>
              {{ space.title }}
            </v-chip>
            <v-spacer />
            <span v-if="member && member.role">
              {{ formatCurrency(member.role.currency, member.role.price) }}
            </span>
          </template>
        </v-card-title>
        <v-list dark>
          <v-divider />
          <v-list-item three-line v-if="member.username">
            <v-list-item-content>
              <v-list-item-title>
                <v-icon small>mdi-account</v-icon>
                <span v-if="member.first_name" v-text="member.first_name" class="mr-2" />
                <span v-if="member.last_name" v-text="member.last_name" />
                <v-chip x-small label class="ml-2">{{member.username}}</v-chip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-icon small>mdi-email</v-icon>
                {{ emailString }}
                <v-icon small>mdi-phone</v-icon>
                {{ member.phone_number }}
              </v-list-item-subtitle>

              <v-list-item-subtitle>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="member && member.role">
              {{ formatCurrency(currency, member.role.price) }}
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>

      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step @click="step=0" :complete="step > 0" step="1">Spaces</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step @click="step=1" :complete="step > 1" step="2">Username and email</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step @click="step=2" :complete="step > 2" step="3">Details</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step @click="step=3" :complete="step > 3" step="4">Done</v-stepper-step>
        </v-stepper-header>
      </v-stepper>

      <v-window-item>
        <v-card flat>
          <v-card-title class='subtitle-1 overline'>
            Which space/s would you like to add this member to?
          </v-card-title>
          <space-picker chips multiple owner-required v-model="selectedSpaces" />
          <template v-if="selectedSpaces && selectedSpaces.length > 0">
            <v-card-title class='subtitle-1 overline'>
              What role should this user have?
            </v-card-title>
            <v-card-text>

              <!-- v-model="member.seat" -->
              <role-picker
                v-if="businessId"
                :package.sync="pkg"
                :role.sync="role"
                :with-package="false"
                :business-id="businessId"
                @selected="setRole" />

              <!-- <role-picker with-package return-object
                v-if="business && business.id && selectedSpaces && selectedSpaces.length > 0"
                :business-id="business.id"
                :pkg.sync="pkg"
                :role.sync="role"
                @selected="step++" /> -->

            </v-card-text>
          </template>
        </v-card>
      </v-window-item>

      <v-window-item>
        <v-card>
          <v-card-title class='subtitle-1 overline'>
            New member's details
          </v-card-title>
          <v-card-text>
            <identity-picker v-if="member"
              v-model="member.username"
              :email.sync="member.email"
              :redirect-email.sync="member.email_route" @done="step++" />

            <!-- <p>
                username: {{member.username}}<br/>
                email: {{member.email}}<br/>
                redirect email: {{member.redirectEmail}}<br/>
              </p> -->

          </v-card-text>

        </v-card>
      </v-window-item>

      <v-window-item>
        <template v-if="member.username && member.email">

          <v-card>
            <v-card-title class='subtitle-1 overline'>
            </v-card-title>
            <v-card-text>

              <v-row>
                <v-col cols="6">
                  <v-text-field persistent-hint label='First name' v-model="member.first_name"
                    hint="The member's first name" />
                </v-col>
                <v-col cols="6">
                  <v-text-field persistent-hint label='Last name' v-model="member.last_name"
                    hint="The member's last name" />
                </v-col>
              </v-row>

              <phone-number-input v-model="member.phone_number" />
              <!-- <v-text-field persistent-hint
              label='phone number'
              v-model="member.phone_number"
              hint="A valid phone number starting with the country code. e.g.: +27831111111" /> -->

              <v-text-field persistent-hint label='Registration number' v-model="member.registration_number"
                hint="e.g.: Your HPCSA number, or your professional registration number (optional)" />

            </v-card-text>
            <v-card-actions>
              <v-btn @click="reset" text >
                <v-icon>mdi-chevron-left</v-icon>
                Start over
              </v-btn>
              <v-spacer />
              <v-btn @click="create" color="primary">Create member</v-btn>
            </v-card-actions>
          </v-card>

          <!-- <pre v-text="member" />
        <pre v-text="payload" />
        <pre v-text="req.result" /> -->

        </template>
      </v-window-item>

      <!-- success -->
      <v-window-item>

        <v-card>
          <v-card-text class='text-center'>
            <v-avatar color='success' size='70'>
              <v-icon dark large>mdi-check</v-icon>
            </v-avatar>

            <blockquote class='blockquote'>
              Successfull added a new member to your team
            </blockquote>

            <center>
              <v-card width="420" >
                <v-card-title class="justify-center" >
                  Login details for {{member.first_name}}
                </v-card-title>
                <v-card-text class="h5" >
                  <blockquote class="blockquote" >
                    <strong>email:</strong> {{member.email}}
                    <v-icon @click="copyText(member.email)" x-small >mdi-content-copy</v-icon>
                    <br/>
                    <strong>password:</strong> {{createdMember.password}}
                    <v-icon @click="copyText('testtest')" x-small >mdi-content-copy</v-icon>
                  </blockquote>

                  <v-alert text color="info" class="caption" >
                    NB: Take note of the password. You won't be able to see it again
                  </v-alert>
                </v-card-text>
              </v-card>


              <v-card flat width="420" class="mt-2" >
                <v-card-title class="justify-center" >
                  Next steps
                </v-card-title>

                <v-row >

                  <v-col cols="6" >
                    <v-btn block rounded outlined
                      @click='reset'
                      color="primary" >
                      <v-icon >mdi-chevron-left</v-icon>
                      Add anothers
                    </v-btn>
                  </v-col>

                  <v-col cols="6" >
                    <!-- {{ `/settings/team/${businessId}/${practitionerId}/` }} -->
                    <v-btn block rounded outlined
                      @click='step=0;$emit("close");goto(`/settings/team/${businessId}/${createdMemberId}/`)' color="primary">
                      Continue editing
                      <v-icon >mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-col>

                </v-row>
              </v-card>
            </center>

          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-btn text @click='step=0'>
              <v-icon>mdi-chevron-left</v-icon>
              Add another
            </v-btn>
            <v-spacer />
            <v-btn text @click='step=0;$emit("close")'>
              Done
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-window-item>
      <!-- <pre v-text="pkg" /> -->
      <!-- <pre v-text="payload" class="caption grey lighten-4 pa-3" /> -->
    </v-window>
  </v-card>
</template>
<script>
import SpacePicker from '@/components/pickers/SpacePicker.vue'
// import RolePicker from './controls/RolePicker.vue'
import RolePicker from '@/components/pickers/RolePicker.vue'
import IdentityPicker from './controls/IdentityPicker.vue'
import PhoneNumberInput from '@/components/fields/PhoneNumberInput.vue'
import { mapGetters } from 'vuex'
import Vue from 'vue'

const BLANK_MEMBER = {
  username: '',
  full_name: '',
  email: '',
  email_route: '',
  phone_number: '',
  role: {},
  package: {},
  registration_number: ''
}

export default {
  name: 'CreateMember',
  props: {
    value: { type: Object, required: true },
    touch: { type: Number, default: 0 },
  },
  components: {
    SpacePicker,
    RolePicker,
    IdentityPicker,
    PhoneNumberInput
  },
  data () {
    return {
      step: 0,
      req: {
        resource: 'ag.team',
        extra: 'add_member',
        method: 'post'
      },
      requests: {
        validate: {
          resource: 'ag.team',
          extra: 'validate',
          method: 'post'
        }
      },
      pkg: null,
      role: null,
      selectedSpaces: [],
      member: BLANK_MEMBER
    }
  },
  computed: {
    ...mapGetters('identity', ['businesses']),
    createdMember () {
      return this.getObjectPath(this.req, 'result', {})
    },
    createdMemberId () {
      return this.getObjectPath(this.createdMember, 'user.id')
    },
    business () {
      if (this.businesses && this.businesses.length > 0) {
        return this.businesses[0]
      }
      return null
    },
    businessId () { return this.getObjectPath(this.business, 'id') },
    requestStatus () { return this.req.status },
    validateResult () {
      return this.getObjectPath(this.requests, 'validate.result', {})
    },
    selectedSpaceObjects () {
      let spaces = []
      if (this.selectedSpaces && this.selectedSpaces.length > 0) {
        this.selectedSpaces.forEach((spaceId) => {
          let space = this.getSpaceById(spaceId)
          if (space) {
            spaces.push(space)
          }
        })
      }
      return spaces
    },
    emailString () {
      if (this.member.email) {
        if (this.member.email === this.member.email_route) {
          return this.member.email
        } else {
          return `${this.member.email} -> ${this.member.email_route}`
        }
      }
      return ''
    },
    payload () {
      let m = JSON.parse(JSON.stringify(this.member))
      m.role = this.getObjectPath(this.member, 'role')
      if (m.phone_number && m.phone_number.length < 3) {
        delete m['phone_number']
      }
      m.spaces = this.selectedSpaces
      if (this.role) { m.role = this.role.id }
      // use ssystem default
      if (this.pkg) { m.package = this.pkg.id }
      return m
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.member = this.value }
      }
    },
    requestStatus () {
      if (this.requestStatus === 200) {
        this.step++
        this.init()
      }
    }
  },
  methods: {
    create () {
      this.req.data = this.payload
      this.$request('save', this.req)
    },
    validateEmail () {
      this.requests.validate.data = {email: this.member.email}
      this.$request('save', this.requests.validate)
    },
    goto (path) {
      this.$emit("close")
      this.$router.push({path})
    },
    setRole (role) {
      this.member.role = role
      this.step++
    },
    reset () {
      this.member = JSON.parse(JSON.stringify(BLANK_MEMBER))
      Vue.set(this.member, 'role', {})
      Vue.set(this.member, 'package', {})
      this.step = 0
    }
  }
}
</script>
